import React, { lazy, Suspense } from "react";

const style = { borderRadius: 5, border: "1px solid lightgrey" };

const flagMap = {
  "United Kingdom": lazy(() => import("./icons/UnitedKingdom")),
  "South Africa": lazy(() => import("./icons/SoulthAfrica")),
  Brazil: lazy(() => import("./icons/Brazil")),
  Kenya: lazy(() => import("./icons/Kenya")),
  Germany: lazy(() => import("./icons/Germany")),
  France: lazy(() => import("./icons/France")),
  Netherlands: lazy(() => import("./icons/NetherLands")),
  Spain: lazy(() => import("./icons/Spain")),
  Poland: lazy(() => import("./icons/Poland")),
  Palestine: lazy(() => import("./icons/Palestine")),
  Greece: lazy(() => import("./icons/Greece")),
  Bermuda: lazy(() => import("./icons/Bermuda")),
  Ireland: lazy(() => import("./icons/Ireland")),
  "Hong Kong": lazy(() => import("./icons/HongKong")),
  Oman: lazy(() => import("./icons/Oman")),
  Austria: lazy(() => import("./icons/Austria")),
  Taiwan: lazy(() => import("./icons/Taiwan")),
  Thailand: lazy(() => import("./icons/Thailand")),
  Russia: lazy(() => import("./icons/Russia")),
  Philippines: lazy(() => import("./icons/Philippines")),
  Bahrain: lazy(() => import("./icons/Bahrain")),
  "New Zealand": lazy(() => import("./icons/NewZealand")),
  Uruguay: lazy(() => import("./icons/Uruguay")),
  Qatar: lazy(() => import("./icons/Qatar")),
  Jordan: lazy(() => import("./icons/Jordan")),
  Turkey: lazy(() => import("./icons/Turkey")),
  Luxembourg: lazy(() => import("./icons/Luxembourg")),
  Peru: lazy(() => import("./icons/Peru")),
  Sweden: lazy(() => import("./icons/Sweden")),
  Belgium: lazy(() => import("./icons/Belgium")),
  India: lazy(() => import("./icons/India")),
  Japan: lazy(() => import("./icons/Japan")),
  Pakistan: lazy(() => import("./icons/Pakistan")),
  Colombia: lazy(() => import("./icons/Colombia")),
  Argentina: lazy(() => import("./icons/Argentina")),
  Kuwait: lazy(() => import("./icons/Kuwait")),
  "Czech Republic": lazy(() => import("./icons/CzechRepublic")),
  Canada: lazy(() => import("./icons/Canada")),
  Australia: lazy(() => import("./icons/Australia")),
  China: lazy(() => import("./icons/China")),
  "Cayman Islands": lazy(() => import("./icons/CaymanIslands")),
  Ukraine: lazy(() => import("./icons/Ukraine")),
  Kazakhstan: lazy(() => import("./icons/Kazakhstan")),
  Finland: lazy(() => import("./icons/Finland")),
  Iraq: lazy(() => import("./icons/Iraq")),
  "United Arab Emirates": lazy(() => import("./icons/UnitedArabEmirates")),
  "South Korea": lazy(() => import("./icons/SouthKorea")),
  Portugal: lazy(() => import("./icons/Portugal")),
  Malaysia: lazy(() => import("./icons/Malaysia")),
  Switzerland: lazy(() => import("./icons/Switzerland")),
  Denmark: lazy(() => import("./icons/Denmark")),
  Mexico: lazy(() => import("./icons/Mexico")),
  Israel: lazy(() => import("./icons/Israel")),
  Egypt: lazy(() => import("./icons/Egypt")),
  Norway: lazy(() => import("./icons/Norway")),
  Chile: lazy(() => import("./icons/Chile")),
  "United States": lazy(() => import("./icons/UnitedStates")),
  Nigeria: lazy(() => import("./icons/Nigeria")),
  Morocco: lazy(() => import("./icons/Morocco")),
  Italy: lazy(() => import("./icons/Italy")),
  Singapore: lazy(() => import("./icons/Singapore")),
  Turkmenistan: lazy(() => import("./icons/Turkmenistan")),
  Iceland: lazy(() => import("./icons/Iceland")),
  Vanuatu: lazy(() => import("./icons/Vanuatu")),
  Tonga: lazy(() => import("./icons/Tonga")),
  Estonia: lazy(() => import("./icons/Estonia")),
  Maldives: lazy(() => import("./icons/Maldives")),
  Guyana: lazy(() => import("./icons/Guyana")),
  "Saudi Arabia": lazy(() => import("./icons/SaudiArabia")),
  Algeria: lazy(() => import("./icons/Algeria")),
  Hungary: lazy(() => import("./icons/Hungary")),
  Vietnam: lazy(() => import("./icons/Vietnam")),
  Madagascar: lazy(() => import("./icons/Madagascar")),
  Albania: lazy(() => import("./icons/Albania")),
  Azerbaijan: lazy(() => import("./icons/Azerbaijan")),
  Curacao: lazy(() => import("./icons/Curacao")),
  Romania: lazy(() => import("./icons/Romania")),
  Niger: lazy(() => import("./icons/Niger")),
  Mauritius: lazy(() => import("./icons/Mauritius")),
  Botswana: lazy(() => import("./icons/Botswana")),
  Ecuador: lazy(() => import("./icons/Ecuador")),
  Guatemala: lazy(() => import("./icons/Guatemala")),
  Paraguay: lazy(() => import("./icons/Paraguay")),
  Myanmar: lazy(() => import("./icons/Myanmar")),
  Tunisia: lazy(() => import("./icons/Tunisia")),
  Angola: lazy(() => import("./icons/Angola")),
  Bulgaria: lazy(() => import("./icons/Bulgaria")),
  Montenegro: lazy(() => import("./icons/Montenegro")),
  Kyrgyzstan: lazy(() => import("./icons/Kyrgyzstan")),
  Sudan: lazy(() => import("./icons/Sudan")),
  "Democratic Republic Of Congo": lazy(
    () => import("./icons/DemocraticRepublicOfCongo")
  ),
  Somalia: lazy(() => import("./icons/Somalia")),
  Malawi: lazy(() => import("./icons/Malawi")),
  "Dominican Republic": lazy(() => import("./icons/DominicanRepublic")),
  Palau: lazy(() => import("./icons/Palau")),
  "Burkina Faso": lazy(() => import("./icons/BurkinaFaso")),
  Ghana: lazy(() => import("./icons/Ghana")),
  "San Marino": lazy(() => import("./icons/SanMarino")),
  Liechtenstein: lazy(() => import("./icons/Liechtenstein")),
  "Sierra Leone": lazy(() => import("./icons/SierraLeone")),
  "El Salvador": lazy(() => import("./icons/ElSalvador")),
  "Sao Tome And Principe": lazy(() => import("./icons/SaoTomeAndPrincipe")),
  Comoros: lazy(() => import("./icons/Comoros")),
  Belize: lazy(() => import("./icons/Belize")),
  Indonesia: lazy(() => import("./icons/Indonesia")),
  Nauru: lazy(() => import("./icons/Nauru")),
  Malta: lazy(() => import("./icons/Malta")),
  "Costa Rica": lazy(() => import("./icons/CostaRica")),
  Armenia: lazy(() => import("./icons/Armenia")),
  Georgia: lazy(() => import("./icons/Georgia")),
  Djibouti: lazy(() => import("./icons/Djibouti")),
  "Saint Kitts And Nevis": lazy(() => import("./icons/SaintKittsAndNevis")),
  Bahamas: lazy(() => import("./icons/Bahamas")),
  Slovakia: lazy(() => import("./icons/Slovakia")),
  "Papua New Guinea": lazy(() => import("./icons/PapuaNewGuinea")),
  Monaco: lazy(() => import("./icons/Monaco")),
  Mozambique: lazy(() => import("./icons/Mozambique")),
  Kiribati: lazy(() => import("./icons/Kiribati")),
  Cyprus: lazy(() => import("./icons/Cyprus")),
  Tuvalu: lazy(() => import("./icons/Tuvalu")),
  Bangladesh: lazy(() => import("./icons/Bangladesh")),
  "North Korea": lazy(() => import("./icons/NorthKorea")),
  Ethiopia: lazy(() => import("./icons/Ethiopia")),
  Belarus: lazy(() => import("./icons/Belarus")),
  Eritrea: lazy(() => import("./icons/Eritrea")),
  "Central African Republic": lazy(
    () => import("./icons/CentralAfricanRepublic")
  ),
  Macedonia: lazy(() => import("./icons/Macedonia")),
  Zambia: lazy(() => import("./icons/Zambia")),
  Dominica: lazy(() => import("./icons/Dominica")),
  "Trinidad And Tobago": lazy(() => import("./icons/TrinidadAndTobago")),
  "Bosnia And Herzegovina": lazy(() => import("./icons/BosniaAndHerzegovina")),
  "South Sudan": lazy(() => import("./icons/SouthSudan")),
  Zimbabwe: lazy(() => import("./icons/Zimbabwe")),
  "Sri Lanka": lazy(() => import("./icons/SriLanka")),
  Micronesia: lazy(() => import("./icons/Micronesia")),
  Nicaragua: lazy(() => import("./icons/Nicaragua")),
  "Marshall Islands": lazy(() => import("./icons/MarshallIslands")),
  "Brunei Darussalam": lazy(() => import("./icons/BruneiDarussalam")),
  Cameroon: lazy(() => import("./icons/Cameroon")),
  Serbia: lazy(() => import("./icons/Serbia")),
  "Timor Leste": lazy(() => import("./icons/TimorLeste")),
  Barbados: lazy(() => import("./icons/Barbados")),
  Togo: lazy(() => import("./icons/Togo")),
  Honduras: lazy(() => import("./icons/Honduras")),
  "Saint Vincent And The Grenadines": lazy(
    () => import("./icons/SaintVincentAndTheGrenadines")
  ),
  Suriname: lazy(() => import("./icons/Suriname")),
  Cambodia: lazy(() => import("./icons/Cambodia")),
  Panama: lazy(() => import("./icons/Panama")),
  Iran: lazy(() => import("./icons/Iran")),
  Lebanon: lazy(() => import("./icons/Lebanon")),
  Lesotho: lazy(() => import("./icons/Lesotho")),
  Seychelles: lazy(() => import("./icons/Seychelles")),
  Venezuela: lazy(() => import("./icons/Venezuela")),
  Moldova: lazy(() => import("./icons/Moldova")),
  Fiji: lazy(() => import("./icons/Fiji")),
  Yemen: lazy(() => import("./icons/Yemen")),
  "Saint Lucia": lazy(() => import("./icons/SaintLucia")),
  Uzbekistan: lazy(() => import("./icons/Uzbekistan")),
  Liberia: lazy(() => import("./icons/Liberia")),
  "Afghanistan Islamic Republic Of": lazy(
    () => import("./icons/AfghanistanIslamicRepublicOf")
  ),
  Jamaica: lazy(() => import("./icons/Jamaica")),
  Latvia: lazy(() => import("./icons/Latvia")),
  Namibia: lazy(() => import("./icons/Namibia")),
  Mali: lazy(() => import("./icons/Mali")),
  Nepal: lazy(() => import("./icons/Nepal")),
  "North Macedonia": lazy(() => import("./icons/NorthMacedonia")),
  Croatia: lazy(() => import("./icons/Croatia")),
  Uganda: lazy(() => import("./icons/Uganda")),
  Slovenia: lazy(() => import("./icons/Slovenia")),
  Samoa: lazy(() => import("./icons/Samoa")),
  Mauritania: lazy(() => import("./icons/Mauritania")),
  Guinea: lazy(() => import("./icons/Guinea")),
  Benin: lazy(() => import("./icons/Benin")),
  Tajikistan: lazy(() => import("./icons/Tajikistan")),
  Senegal: lazy(() => import("./icons/Senegal")),
  Haiti: lazy(() => import("./icons/Haiti")),
  Rwanda: lazy(() => import("./icons/Rwanda")),
  Bolivia: lazy(() => import("./icons/Bolivia")),
  Grenada: lazy(() => import("./icons/Grenada")),
  Burundi: lazy(() => import("./icons/Burundi")),
  Cuba: lazy(() => import("./icons/Cuba")),
  Gambia: lazy(() => import("./icons/Gambia")),
  "Solomon Islands": lazy(() => import("./icons/SolomonIslands")),
  Tanzania: lazy(() => import("./icons/Tanzania")),
  Chad: lazy(() => import("./icons/Chad")),
  "Cabo Verde": lazy(() => import("./icons/CaboVerde")),
  "Equatorial Guinea": lazy(() => import("./icons/EquatorialGuinea")),
  Mongolia: lazy(() => import("./icons/Mongolia")),
  Lithuania: lazy(() => import("./icons/Lithuania")),
  Libya: lazy(() => import("./icons/Libya")),
  Laos: lazy(() => import("./icons/Laos")),
  Bhutan: lazy(() => import("./icons/Bhutan")),
  Gabon: lazy(() => import("./icons/Gabon")),
  "Guinea Bissau": lazy(() => import("./icons/GuineaBissau")),
  "Cote D'Ivoire": lazy(() => import("./icons/CoteDIvoire")),
  Eswatini: lazy(() => import("./icons/Eswatini")),
  Kosovo: lazy(() => import("./icons/Kosovo")),
  "European Union": lazy(() => import("./icons/EuropeanUnion")),
  "All Countries": lazy(() => import("./icons/AllCountries")),
};

const DEFAULT_FLAG = "All Countries";

const CountryFlag = ({ country }) => {
  let Flag = flagMap[country];

  if (!Flag) {
    Flag = flagMap[DEFAULT_FLAG];
  }

  return (
    <Suspense fallback="">
      <Flag style={style} />
    </Suspense>
  );
};

export default CountryFlag;
